import { render, staticRenderFns } from "./CourseCompareTray.vue?vue&type=template&id=34c53930&scoped=true&"
import script from "./CourseCompareTray.vue?vue&type=script&lang=js&"
export * from "./CourseCompareTray.vue?vue&type=script&lang=js&"
import style0 from "./CourseCompareTray.vue?vue&type=style&index=0&id=34c53930&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c53930",
  null
  
)

export default component.exports